import I from 'immutable';
import _ from 'underscore';
import Flux from 'lib/flux';

const Stores = Flux.Stores.reduce(function (stores, store) {
  stores[store.name] = store;
  return stores;
}, {});

const StoreInterestMixin = {
  componentDidMount() {
    const storeInterests = this.getStoreInterests();
    const self = this;
    this._reverseStoreIndex = {};

    _.each(storeInterests, function (storePath, stateKey) {
      const storeSegments = storePath.split('.');
      const store = storeSegments.shift();

      if (self._reverseStoreIndex[store] === undefined) {
        // First time we meet with this store, so we need
        // to register interest
        Stores[store].changed.add(self._handleStoreChange);
        self._reverseStoreIndex[store] = {};
      }

      self._reverseStoreIndex[store][stateKey] = storeSegments;
    });
  },

  componentWillUnmount() {
    const self = this;
    _.each(this._reverseStoreIndex, function (_storeDef, store) {
      Stores[store].changed.remove(self._handleStoreChange);
    });
  },

  _handleStoreChange(store, newState) {
    const self = this;
    const mutation = {};

    _.each(this._reverseStoreIndex[store], function (storePath, stateKey) {
      const newStateNode = newState.getIn(storePath);
      if (!I.is(self.state[stateKey], newStateNode)) {
        mutation[stateKey] = newStateNode;
      }
    });

    if (!_.isEmpty(mutation)) {
      this.setState(mutation);
    }
  },
};

export default StoreInterestMixin;
